import React from 'react';
import './animations.css';
import graduationicon from "../Assets/graduationicon.png";
import icon01 from "../Assets/icon01.png";
import icon02 from "../Assets/icon02.png";
import icon03 from "../Assets/icon03.png";
import icon04 from "../Assets/icon04.png";
import icon05 from "../Assets/icon05.png";

const categories = [
    { icon: icon04, name: "Community Health", meta: "" },
    { icon: icon05, name: "Community Health Extension Worker", meta: "" },
    { icon: graduationicon, name: "Junior Community Health Extension Worker", meta: "" },
    { icon: icon01, name: "Medical Laboratory Science", meta: "1" },
    { icon: icon02, name: "Pharmacy Technician", meta: "" },
    { icon: icon03, name: "Dispensary & Optometry Technician", meta: "" },
];

const Coursecategories = () => {
    return (
        <div className="w-full bg-[#F6F5F1] pt-20 pb-24 px-4 md:px-10 lg:px-16">

            <div className="flex flex-col items-center text-center mb-16">
                <div className="flex items-center gap-2 mb-5">
                    <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                    <span className="text-[#B8862E] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                        Programs
                    </span>
                    <span className="w-6 h-[1.5px] bg-[#B8862E]" />
                </div>
                <h2
                    className="text-3xl md:text-4xl text-[#12213D] leading-tight mb-4"
                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                >
                    All course categories
                </h2>
                <p
                    className="text-[#5B6472] text-base md:text-lg leading-relaxed max-w-xl"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                >
                    A comprehensive range of educational programs and subjects offered across various fields, giving learners diverse opportunities to build knowledge, skills, and qualifications.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#12213D]/10">
                {categories.map((cat) => (
                    <div
                        key={cat.name}
                        className="border-r border-b border-[#12213D]/10 bg-white flex flex-col items-center text-center px-8 py-10"
                    >
                        <img src={cat.icon} className="w-20 md:w-24 mb-5" alt={cat.name} />
                        <p className="text-[#12213D]" style={{ fontFamily: "'Inter', sans-serif" }}>
                            {cat.name}
                        </p>
                        <p className="text-[#B8862E] text-sm mt-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                            {cat.meta}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Coursecategories;